import React from "react"

import { AppAntSwitch } from "@components"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { boolean, object } from "yup"


export default function ReportProvidersExclusionSwitch() {
	const {
		filterProvidersExclusion,
		setFilterProvidersExclusionInfo,
	} = useReportFormInfo(reportFormData.peek().filterProvidersExclusion, "filterProvidersExclusion", object({ filterProvidersExclusion: boolean() }))

	return <AppAntSwitch
		trueText="Exclude providers"
		checked={!!filterProvidersExclusion}
		onChange={e => setFilterProvidersExclusionInfo(e.target.checked)}
	/>
}